import React, { createContext, useState, useContext, ReactNode } from 'react';


interface NavigationContextProps {
    hasNavigatedFromRoot: boolean;
    handleNavigationFromRoot: () => void;
}

const NavigationContext = createContext<NavigationContextProps | undefined>(undefined);

export const NavigationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [hasNavigatedFromRoot, setHasNavigatedFromRoot] = useState<boolean>(false);

    const handleNavigationFromRoot = () => {
        setHasNavigatedFromRoot(true);
    };

    return (
        <NavigationContext.Provider value={{ hasNavigatedFromRoot, handleNavigationFromRoot }}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigation = (): NavigationContextProps => {
    const context = useContext(NavigationContext);
    if (context === undefined) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
};
